import { useStore } from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import Accordion from './Accordion';

const BrandKitWebsite = observer(() => {
  const videoCreator = useVideoCreatorStore();
  const { datoClientStore } = useStore();

  const branding = videoCreator.organization?.branding;
  const website = branding?.organizationWebsite;
  const [value, setValue] = useState('');

  useEffect(() => {
    if (website) setValue(website);
  }, [Boolean(website)]);

  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const handleSave = async () => {
    setIsSaving(true);
    setIsSaved(false);
    const organization = videoCreator.organization;
    organization!.branding = {
      ...organization!.branding!,
      organizationWebsite: value.trim(),
    };
    await datoClientStore.albumRepository?.update(organization!);
    setIsSaving(false);
    setIsSaved(true);
  };

  const isChanged = value !== website;

  return (
    <Accordion id="org-website" title="Organization Website" isSaved={isSaved}>
      <Container isSaving={isSaving}>
        <div className="input-wrapper">
          <input
            type="url"
            value={value}
            onChange={e => setValue(e.target.value)}
            placeholder="Enter your organization's website"
          />
        </div>
        <div className="actions">
          <button disabled={isSaving || !isChanged} onClick={handleSave}>
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </Container>
    </Accordion>
  );
});

const Container = styled.div<{ isSaving?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
    border: 1px solid var(--border);
    border-radius: 8px;

    &:focus-within {
      border-color: var(--text-secondary);
    }

    > input {
      color: var(--text-secondary);
      font-family: var(--font-primary);
      font-size: var(--text-sm);
      font-weight: var(--font-weight-regular);
      background: transparent;
      outline: none;
      border: none;
      resize: none;
      padding: 24px;
      &::placeholder {
        color: var(--text-muted);
      }
    }
  }

  .actions {
    align-self: flex-end;

    > button {
      display: block;
      height: 48px;
      padding: 12px 24px;
      border-radius: 8px;
      background: var(--primary);
      color: var(--background);
      font-size: var(--text-sm);
      font-weight: var(--font-weight-bold);
      border: none;
      transition: var(--transition-normal);
      opacity: ${({ isSaving }) => (isSaving ? 0.6 : 1)};
      cursor: ${({ isSaving }) => (isSaving ? 'not-allowed' : 'pointer')};
      &:disabled {
        color: var(--text-muted);
        border: 1px solid var(--text-muted);
        background: transparent;
        cursor: not-allowed;
      }
      &:hover:not(:disabled) {
        filter: brightness(1.2) saturate(1.2);
      }
    }
  }
`;

export default BrandKitWebsite;
